import { useTranslation } from "react-i18next";
import { IconTrashX } from "@tabler/icons-react";
import { useCurrentUser } from "../../../../domains/user/hooks/useCurrentUser";
import { pushSettingsView } from "../../../../domains/app/stores/settingsSheetStore";
import { SettingsRow } from "../SettingsRow";
import { SettingsSubHeader } from "../SettingsSubHeader";

export function AccountView(): React.JSX.Element {
  const { t } = useTranslation();
  const { currentUser } = useCurrentUser();

  return (
    <div className="flex h-full flex-col">
      <SettingsSubHeader title={t("Account")} />
      <div className="flex flex-1 flex-col overflow-y-auto scroll-fog-y px-5 pb-12">
        <div className="flex flex-col divide-y divide-ds-slate-100">
          {/* Email is read-only (no change-email flow) — a static value row. */}
          <SettingsRow
            icon={null}
            title={t("Email")}
            subtitle={null}
            right={{
              kind: "text",
              text: currentUser === null ? "" : currentUser.email,
            }}
            tone="default"
            onClick={null}
          />
        </div>

        {/* Spacer pushes Delete account to the bottom of the sheet. */}
        <div className="flex-1" />

        <SettingsRow
          icon={<IconTrashX size={20} stroke={1.5} />}
          title={t("Delete account")}
          subtitle={null}
          right={{ kind: "chevron" }}
          tone="danger"
          onClick={() => {
            pushSettingsView({ view: "deleteConfirm" });
          }}
        />
      </div>
    </div>
  );
}
